"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = exports.ProgressDotsSvg = void 0;
var _typeHelpers = require("../../typeHelpers.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var getSize = exports.getSize = function getSize(size) {
  switch (size) {
    case 'small':
      return 56;
    case 'medium':
      return 84;
    case 'large':
      return 112;
    default:
      return (0, _typeHelpers.assertNever)(size);
  }
};
var ProgressDotsSvg = exports.ProgressDotsSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ProgressDotsSvg",
  componentId: "sc-18dhrwh-0"
})(["content:'';block-size:", "px;inline-size:", "px;"], function (props) {
  return getSize(props.$size) / 4.5;
}, function (props) {
  return getSize(props.$size);
});